import { createReducerContext } from '../../../../utils/create-reducer-context';
import { QuestionAnswerCategoryState, QuestionAnswerCategoryReducer, ACTION_TYPES } from './question-answer-category-reducer';

const initialState: QuestionAnswerCategoryState = {
    categories: [],
    loading: false,
    drawer: { open: false },
};

const { Provider: QuestionAnswerCategoryProvider, useStateContext: useQuestionAnswerCategoryState, useDispatchContext: useQuestionAnswerCategoryDispatch } = createReducerContext('QuestionAnswerCategory', QuestionAnswerCategoryReducer, initialState);

export { QuestionAnswerCategoryProvider, useQuestionAnswerCategoryState, useQuestionAnswerCategoryDispatch, ACTION_TYPES };
